<script>
  import { appState } from "../../../../stores";

  // Props
  export let minimal = false;

  // State
  $: ({ currentPage, numberOfResults } = $appState);
  $: low = currentPage > 1 ? (currentPage - 1) * 25 + 1 : 1;
  $: high = Math.min(currentPage * 25, numberOfResults);

  /**
   * Formats numbers greater than 1000 to readable thousands with commas
   * I.e. 2000000 formats to 2,000,000
   * @param n number
   */
  const formatThousands = (n) => {
    return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
</script>

{#if minimal}
  <span>{low}-{high}</span>
{:else}
  <p>{low} - {high} of {formatThousands(numberOfResults)} Results</p>
{/if}
